import { createSlice } from '@reduxjs/toolkit';

import { queryContactList, 
  queryProductList, queryProductUnitList,
  querySpecList, querySpecUnitList,
  queryMaterialList, queryMaterialUnitList,
  queryProcessList, queryProcessUnitList,
} from './work-order-thunk';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    contact_list: [],
    product_list: [],
    product_unit_list: [],
    spec_list: [],
    spec_unit_list: [],
    mat_list: [],
    mat_unit_list: [],
    process_list: [],
    process_unit_list: [],
  },
  reducers: {

  },
  extraReducers: (builder) => {
    builder.addCase(queryContactList.fulfilled, (state, action) => {
      state.contact_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(queryProductList.fulfilled, (state, action) => {
      state.product_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(queryProductUnitList.fulfilled, (state, action) => {
      state.product_unit_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(querySpecList.fulfilled, (state, action) => {
      state.spec_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(querySpecUnitList.fulfilled, (state, action) => {
      state.spec_unit_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(queryMaterialList.fulfilled, (state, action) => {
      state.mat_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(queryMaterialUnitList.fulfilled, (state, action) => {
      state.mat_unit_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(queryProcessList.fulfilled, (state, action) => {
      state.process_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

    builder.addCase(queryProcessUnitList.fulfilled, (state, action) => {
      state.process_unit_list = action.payload.map((t,i) => {
        return t._id;
      });
    });

  }
});

export const actions = appSlice.actions;
export default appSlice.reducer;